import actions from "./actions";

const stateDefault = {
    activeConsents: [],
    consentsStory: [],
};

export default function consentReducer(state = stateDefault, action: { type: string; payload: any; }): any {
    switch (action.type) {
        case actions.SET_ACTIVE_CONSENTS:
            return {...state, activeConsents: action.payload};
        case actions.SET_CONSENTS_STORY:
            return {...state, consentsStory: action.payload};
        case actions.SET_INITIAL_CONSENTS:
            return stateDefault
        default:
            return state
    }
}
